<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex sm3>
            <v-text-field
              name="code"
              label="Code"
              type="text"
              class="mr-1"
              v-model="queryParams.code"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="accName"
              label="Acccount Name"
              type="text"
              class="mr-1"
              v-model="queryParams.accName"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="typeList"
              label="Account Type"
              v-model="queryParams.type"
              item-text="accTypeName"
              item-value="id"
              class="mr-1"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="accountHeadList"
              label="Account Head"
              v-model="queryParams.accountheadId"
              item-text="accountName"
              item-value="id"
              class="mr-1"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch()">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex 12 class="mt-1">
          <v-card>
            <v-data-table
              v-model="selectedAccountList"
              :headers="headers"
              :items="accountList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAllAccount()"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedAccountList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>{{ props.item.code }}</td>
                <td>{{ props.item.accName }}</td>
                <td>{{ props.item.accountTypeName }}</td>
                <td>{{ props.item.nature }}</td>
                <td>{{ props.item.accounthead.accountName }}</td>
                <td>{{ props.item.parentCode }}</td>
                <td>
                  {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  <v-icon
                    v-if="props.item.status == 'ACTIVE'"
                    medium
                    color="green"
                    >check_circle</v-icon
                  >
                  <v-icon v-else medium color="red">cancel</v-icon>
                </td>
                <td></td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="dialogClose">Ok</v-btn>
            </div>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { chartOfAccountService } from "../../services/chart-of-account-service";
import { accountHeadService } from "../../services/account-head-service";
import { accountTypeService } from "../../services/account-type-service";

export default {
  name: "MultiSelectAccountDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },

  data: () => ({
    showListLoading: false,
    queryParams: {
      code: "",
      accName: "",
      accountheadId: "",
      type: "",
      status: "",
      isParent: false,
    },
    headers: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "accName" },
      { text: "Type", value: "type" },
      { text: "Nature", value: "nature" },
      { text: "Account Head", value: "accounthead.accountName" },
      { text: "Parent Code", value: "accountParent.code" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
      { text: "Status", value: "status" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    accountList: [],
    selectedAccountList: [],
    accountHeadList: [],
    typeList: [],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getAccountList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = { ...this.params };
          this.accountList = [];
          this.selectedAccountList = [];
          this.getAccountList();
        }
      },
    },
  },

  created() {
    this.getActiveAccountTypeList();
    this.getAllAccountHeadList();
  },

  methods: {
    getActiveAccountTypeList() {
      accountTypeService
        .getAccountTypeByStatus("ACTIVE")
        .then((res) => {
          this.typeList = res.data;
          this.typeList.unshift({ id: "", accTypeName: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getAllAccountHeadList() {
      accountHeadService
        .getAllAccountHead()
        .then((res) => {
          this.accountHeadList = res.data;
          this.accountHeadList.unshift({ id: "", accountName: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getAccountList();
    },

    getAccountList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      chartOfAccountService
        .getChartOfAccountList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountList = res.data.chartOfAccountList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    toggleAllAccount() {
      if (this.selectedAccountList.length) {
        this.selectedAccountList = [];
      } else {
        this.selectedAccountList = this.accountList.slice();
      }
    },

    dialogClose() {
      this.$emit("close", this.selectedAccountList);
    },
  },
};
</script>
